import React, { useState } from "react";
import { WeekSelect } from "./WeekSelect";
import type { Team } from "../../../types/team";

function lastFullISOWeekRange(now = new Date()) {
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const isoDay = ((today.getDay() + 6) % 7) + 1;

  const currentMonday = new Date(today);
  currentMonday.setDate(today.getDate() - (isoDay - 1));

  const prevMonday = new Date(currentMonday);
  prevMonday.setDate(currentMonday.getDate() - 7);

  const prevSunday = new Date(prevMonday);
  prevSunday.setDate(prevMonday.getDate() + 6);

  return { start: prevMonday, end: prevSunday };
}

type PeriodSelectProps = {
  name?: string;
  onDateChange?: (date: Date) => void;
  teams?: unknown[];
};

export const PeriodSelect = ({
  name = "Period",
  onDateChange,
  teams,
}: PeriodSelectProps) => {
  const [internalDate, setInternalDate] = useState(lastFullISOWeekRange().end);
  const currentDate = internalDate;
  const teamList: Team[] = Array.isArray(teams) ? (teams as Team[]) : [];

  const handleDateChange = (date: Date) => {
    setInternalDate(date);
    onDateChange?.(date);
  };

  return (
    <div
      className="select-component__duration-section"
      style={{ overflow: "visible", marginBottom: "00px", marginTop: "0px" }}
    >
      <div className="duration-field-row">
        <p>{name}</p>
        <WeekSelect
          teams={teamList}
          selectedDate={currentDate}
          onDateChange={handleDateChange}
        />
      </div>
    </div>
  );
};
